/*
  import { lotFileDocumentStore } from '@/services/LotFileDocument/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { notifyProblem, notifyError, notifyMessage } from '@/services/notify'
import kms from '@/services/kms'
import _get from 'lodash/get'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await lotFileDocumentStore.dispatch ('getLotFileDocumentList', {
      hoaId
    });
  */

  async getLotFileDocumentList({}, { unitID, ownerID, includeSignedUrls }) {
    console.log('in getLotFileDocumentList...' + unitID + ', ' + ownerID + ', ' + includeSignedUrls)
    try {
      const params = {
        unitID,
        ownerID,
        includeSignedUrls
      }

      const results = await kms.get(`/LotFiles/LotFileDocument/List`, {
        params
      })

      if (isDebug == true) console.debug('getLotFileDocumentList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Lot File Document list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getLotFileCategoryList({}, { hoaID }) {
    console.log('in getLotFileCategoryList...' + hoaID)
    try {
      const params = {
        hoaID
      }

      const results = await kms.get(`/LotFiles/LotFileCategory/List`, {
        params
      })

      if (isDebug == true) console.debug('getLotFileCategoryList log=' + JSON.stringify(results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Lot File Category list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async updateLotFileDocument({ dispatch }, { payload = {}, done }) {
    try {
      if (isDebug === true)
        console.debug('updateLotFileDocument payload=' + JSON.stringify(payload))

      const results = await kms.put(`/LotFiles/LotFileDocument`, payload)

      console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.lotFileDocumentID > 0) {
        notifyMessage(`Successfully updated the lot file document.`)
        done()
      } else {
        notifyError('There was a problem updating this lot file document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem processing the update for this lot file document.`)
      console.error(exception)
    }
  },

  async createLotFileDocument({ dispatch }, { payload = {}, done }) {
    try {
      if (isDebug === true)
        console.debug('createLotFileDocument payload=' + JSON.stringify(payload))

      const results = await kms.post(`/LotFiles/LotFileDocument`, payload)

      console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (results.lotFileDocumentID > 0) {
        notifyMessage(`Successfully added the lot file document.`)
        done({ detail: results })
      } else {
        notifyError('There was a problem adding this lot file document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem adding the lot file document.`)
      console.error(exception)
    }
  },

  async getUniqueCategories({}, { rows }) {
    try {
      console.debug('getUniqueCategories...' + JSON.stringify(rows))
      let resultList = []
      let myList = []
      rows.forEach(f => {
        if (f && f.lotFileCategory !== undefined && f.lotFileCategory.name !== undefined) {
          const filterCategory = {
            label: f.lotFileCategory.name || '',
            value: f.lotFileCategoryID,
            filter: ''
          }

          if (f.lotFileCategory.name !== '') {
            myList.push(filterCategory)
          }
        }
      })

      if (!myList) {
        myList = [
          {
            label: 'All',
            value: 0,
            filter: ''
          }
        ]
      }

      resultList = [...new Set(myList)]

      return {
        list: resultList
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving unique filter categories`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getFile({}, { params = {} }) {
    try {
      const result = await kms.get(`/LotFiles/LotFileDocument/GetFile`, {
        params
      })

      if (isDebug == true) console.debug('getFile=' + result)

      return {
        returned: result
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving the lot file document file.`)
      console.error(exception)
    }

    return {
      returned: null
    }
  },

  async getDocumentFromPath({}, { path }) {
    try {
      const result = await kms.getfrompath(path)

      if (isDebug == true) console.debug('getDocumentFromPath=' + result)

      return {
        returned: result
      }
    } catch (exception) {
      notifyProblem(`There was a problem retrieving signed document.`)
      console.error(exception)
    }

    return {
      returned: null
    }
  },

  async uploadDocument({ dispatch }, { payload = {}, done }) {
    const formData = new FormData()
    formData.append('file', payload.file)

    try {
      const path = `/LotFiles/LotFileDocument/StoreFile?lotFileDocumentID=${payload.lotFileDocumentID}`
      const uploadedLotFileDocumentFile = await kms.post(path, formData, {
        'Content-Type': 'multipart/form-data'
      })

      console.debug('uploadDocument path=' + path)

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      if (isDebug == true)
        console.debug(
          'upload lot file document with payload=' + JSON.stringify(uploadedLotFileDocumentFile)
        )

      done({ returnedFile: uploadedLotFileDocumentFile })
    } catch (e) {
      notifyError(e)
    }
  },

  async deleteLotFileDocument({ dispatch }, { lotFileDocumentID, done }) {
    try {
      const path = `/LotFiles/LotFileDocument/${lotFileDocumentID}?forceDelete=false`

      const results = await kms.delete(path)

      if (this.isDebug == true) console.debug('results=' + JSON.stringify(results))

      if (dispatch && dispatch != undefined) console.debug(dispatch)

      const wasDeleted = _get(results, 'deleted', false)

      if (wasDeleted === true) {
        notifyMessage(`Successfully deleted the lot file document.`)
        done()
      } else {
        notifyError('There was a problem deleting the lot file document.')
      }
    } catch (exception) {
      notifyProblem(`There was a problem deleting the lot file document.`)
      console.error(exception)
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const lotFileDocumentStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
